/**
 * A footer link. `external` links open a new tab and carry toncenter.com's
 * arrow; the others navigate in place (toncenter.com's own sections, and
 * `Health` — this page — marked `current`).
 */
export interface FooterLink {
  label: string;
  href: string;
  external?: boolean;
  current?: boolean;
}

// toncenter.com's footer navigation, in its order (DESIGN.md §10). The
// in-page anchors of toncenter.com point back at toncenter.com from here.
export const FOOTER_LINKS: readonly FooterLink[] = [
  { label: 'APIs', href: 'https://toncenter.com/#apis' },
  { label: 'Metrics', href: 'https://toncenter.com/#metrics' },
  { label: 'Health', href: '/', current: true },
  { label: 'GitHub', href: 'https://github.com/toncenter', external: true },
  { label: 'News', href: 'https://t.me/toncenter_news', external: true },
  { label: 'Help', href: 'https://t.me/toncenter_help_bot', external: true },
  {
    label: 'Terms',
    href: 'https://toncenter.com/toncenter_gtc.pdf',
    external: true,
  },
];
